<script setup lang="ts">
import {LegacyDelivery, LegacyStateTransition} from '@hantera/portal-app';


const props = defineProps<{
  data: {
    delivery: LegacyDelivery
    transition: LegacyStateTransition
  }
}>();

// TODO: Add localization

</script>

<template>
  <div class="timeline-delivery-state-change">
    Delivery <span class="timeline-delivery-state-change__number">{{ data.delivery.deliveryNumber }}</span> state changed
    from
    <span
      class="timeline-delivery-state-change__state"
      :style="`background-color: var(--state-colors__delivery-${data.transition.fromState?.toLowerCase()})`"
    >{{ data.transition.fromState }}</span> to <span
      class="timeline-delivery-state-change__state"
      :style="`background-color: var(--state-colors__delivery-${data.transition.toState?.toLowerCase()})`"
    >{{ data.transition.toState }}</span>
  </div>
</template>

<style>
.timeline-delivery-state-change {
  max-width: 800px;
  margin-top: -4.5px;
}

.timeline-delivery-state-change__color-indicator {
  display: inline-block;
  width: 5px;
  border-radius: 5px;
  height: 20px;
  vertical-align: sub;
  margin: 0 2px;
}

.timeline-delivery-state-change__timestamp,
.timeline-delivery-state-change__number {
  font-weight: 600;
}

.timeline-delivery-state-change__state {
  font-weight: 600;
  color: white;
  display: inline-block;
  padding: 4px 4px 3px 4px;
  border-radius: 4px;
}
</style>